import Spacer from "@/components/Spacer";

import UserInfoHeader from "@/components/UserInfoHeader";
import InfoCard from "@/components/InfoCard";
import CurrentStageCard from "./components/CurrentStageCard";
import { useDashboard } from "./useDashboard";

import { getStorageImageUrl } from "@/utils/get-storage-image-url";
import { useGetCompletedChallenges } from "@/hooks/useGetCompletedChallenges";
import { useGetCompletedCourses } from "@/hooks/useGetCompletedCourses";
import { usePdcExternalCoursesQuery } from "@/hooks/usePdcExternalCoursesQuery";
import { ENABLE_POINTS_UI } from "@/utils/feature-flags";
import { realityInfo } from "@/utils/realityInfo";
import { isPdcExternalCourseListEnabled } from "@/utils/pdc-external-course-list";
import { derivePdcCourseListStats } from "@/services/pdcExternal/courses";
import { syncPdcCourseProgressToRealityThenRefreshQueries } from "@/services/courses";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

function Dashboard() {
  const location = useLocation();
  const { submittedChallengesCount } = useGetCompletedChallenges();
  const usePdcList = isPdcExternalCourseListEnabled();
  const nestCourses = useGetCompletedCourses();
  const pdcQuery = usePdcExternalCoursesQuery({ enabled: usePdcList });

  /** Each visit to /dashboard + fresh PDC list: persist progress in Nest and refresh UI caches. */
  useEffect(() => {
    if (location.pathname !== "/dashboard") return;
    if (!usePdcList || !pdcQuery.isSuccess) return;
    void syncPdcCourseProgressToRealityThenRefreshQueries();
  }, [location.key, location.pathname, usePdcList, pdcQuery.isSuccess]);

  /** Dashboard: só cursos concluídos (100% / FINISHED), não “iniciados”. */
  const completedCoursesForCounter = useMemo(() => {
    if (usePdcList && pdcQuery.data !== undefined) {
      return derivePdcCourseListStats(pdcQuery.data).completedCoursesCount;
    }
    return nestCourses.completedCoursesCount;
  }, [usePdcList, pdcQuery.data, nestCourses.completedCoursesCount]);
  const { handleNavigateToCourse, handleNavigateToChallenges } = useDashboard();

  return (
    <div>
      <CurrentStageCard />

      <UserInfoHeader />

      <Spacer height="2rem" />
      <InfoCard
        imageSrc={getStorageImageUrl("dashboard_challenges.png")}
        title="Desafios"
        description={
          ENABLE_POINTS_UI
            ? realityInfo.dashboardChallengesText
            : "Mostre suas habilidades do dia a dia com nossos desafios! São desafios rápidos que vão te deixar ainda mais perto do título."
        }
        buttonCta="Ir para Desafios"
        completedCounter={submittedChallengesCount}
        onClick={handleNavigateToChallenges}
      />

      <Spacer height="2rem" />
      <InfoCard
        imageSrc={getStorageImageUrl("dashboard_courses.png")}
        title="Cursos"
        description={
          ENABLE_POINTS_UI
            ? "Adquira conhecimento e aumente sua pontuação através dos cursos e provas. Quanto mais acertos, mais pontos você conquista!"
            : "Adquira conhecimento através dos cursos e provas e evolua no programa."
        }
        buttonCta="Ir para Cursos"
        completedCounter={completedCoursesForCounter}
        onClick={handleNavigateToCourse}
      />
    </div>
  );
}

export default Dashboard;
